// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"fd4d37dd","225":"fec4fd2e","248":"9c37df33","461":"d0656ce7","813":"acea89fd","839":"19020315","961":"968f3ec7"}[chunkId] + ".chunk.css";
};